import React, { Fragment, Component, cloneElement, useState, useEffect } from 'react'
import {
  Datagrid, TextInput, BulkDeleteButton,
  List, Pagination, Filter, BooleanInput,
  TopToolbar, sanitizeListRestProps, Button, useDataProvider
} from 'react-admin'
import BulkActionButton from '../utilities/BulkActionButton'
import { Page, Text, View, Document, StyleSheet, pdf, PDFDownloadLink } from '@react-pdf/renderer';
import TheBox from './TheBox'
import ResponsiveIFrame from './ResponsiveIFrame'
import { InputAdornment } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import {
  Button as MaterialUIButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as MaterialUITextField,
  Input,
  Select, MenuItem, InputLabel

} from "@material-ui/core";
import { Scrape, GetProgress, UpdateProgress, keepAccessTokenUpdated } from '../utilities/extraAPIs'



// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    fontFamily: 'Helvetica'
  },
  section: {
    marginLeft: 10,
    flexGrow: 1
  }
});

const MyDoc = (PdfObj = {}) => {

  const [allPages, setAllPages] = useState([])

  useEffect(() => {
    const rowPerPage = 68
    let lanesArr = Object.keys(PdfObj)


    let sectionRowCount = 0
    let pages = []
    let page = []
    let sectionObj = {}
    let onLeftSide = true
    for (let index = 0; index < lanesArr.length; index++) {
      const lane = lanesArr[index]
      const totalRunForThisLane = PdfObj[lane].length

      sectionRowCount += 2 //Lane Title Height:2
      sectionRowCount += totalRunForThisLane //small text height: 1



      if (sectionRowCount < rowPerPage) {
        sectionObj[lane] = PdfObj[lane]
      }
      else {
        let start = rowPerPage - (sectionRowCount - totalRunForThisLane - 2)
        sectionObj[lane] = PdfObj[lane].slice(0, start)
        page.push(sectionObj)
        onLeftSide = false

        sectionObj = {}

        let laneLeftRun = totalRunForThisLane - start
        if (laneLeftRun > 0) {
          const round = Math.floor(laneLeftRun / rowPerPage) + 1
          for (let currentRound = 1; currentRound <= round; currentRound++) {
            sectionObj[lane] = PdfObj[lane].slice(start, start + ((rowPerPage - 2) * currentRound))
            if (sectionObj[lane].length >= rowPerPage - 2 || index == lanesArr.length - 1) {
              page.push(sectionObj)
            }
            if (!onLeftSide) {
              pages.push(page)
              page = []
              sectionObj = {}
            }
            onLeftSide = !onLeftSide
            start = start + ((rowPerPage - 2) * currentRound)
          }

        }

        sectionRowCount = totalRunForThisLane % rowPerPage
        if (totalRunForThisLane % rowPerPage > 0) {
          sectionRowCount += 2
        }

      }

      if (index == lanesArr.length - 1 && Object.keys(sectionObj).length > 0) {
        page.push(sectionObj)
      }

      if (index == lanesArr.length - 1 && page.length > 0) {
        pages.push(page)
      }

    }


    console.log('--', pages);
    setAllPages(pages)
  }, [PdfObj])



  return (
    <Document>

      {

        allPages.map((page, index) => {
          return (<Page size="LETTER" style={styles.page} >
            {
              page.map((section, index) => {
                return (<View style={styles.section} >
                  {
                    Object.keys(section).map((lane, inedx) => {
                      return (
                        <View  >
                          <Text >{lane}</Text>
                          {
                            section[lane].map((car, index) => {
                              let { id, lane_number, run_number, year, make, model, mileage, valuation, note, color } = car
                              return <Text style={{ fontSize: '10pt', backgroundColor: `${index % 2 == 0 ? '#e8e8e8' : 'white'}` }} ><Text style={{ fontFamily: 'Helvetica-Bold', }}>{`${lane_number ? lane_number + ' - ' + run_number : ''}`}</Text>{` ${year} ${make} ${model} ${color} ${mileage} `}<Text style={{ fontFamily: 'Helvetica-Bold', }}>{valuation}</Text>{` ${note}`}</Text>
                            })
                          }
                        </View>
                      )
                    })

                  }

                </View>)
              })
            }


          </Page>)

        })

      }


    </Document>
  )
}

const Link = ({ toDownload }) => {

  return (
    <PDFDownloadLink document={toDownload} fileName="Homework.pdf">
      {({ blob, url, loading, error }) => {
        return (loading ? 'Loading document...' : 'Download now!')
      }}
    </PDFDownloadLink>
  )
}

const ListActions = ({
  currentSort, className, resource, filters,
  displayedFilters, exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues, permanentFilter, hasCreate, // you can hide CreateButton if hasCreate = false
  basePath, selectedIds, onUnselectItems, showFilter, maxResults,
  total, rate, setRate, ids, page, perPage,
  ...rest
}) => {

  const [hasEmptyCarfax, setHasEmptyCarfax] = useState(true)
  const [hasEmptyMMR, setHasEmptyMMR] = useState(true)


  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [isScrapingAdesa, setIsScrapingAdesa] = useState(true)
  const [isScrapingAdesaUS, setIsScrapingAdesaUS] = useState(true)
  const [isScrapingAutoNation, setIsScrapingAutoNation] = useState(true)
  const [isScrapingMMR, setIsScrapingMMR] = useState(true)
  const [isScrapingCarfax, setIsScrapingCarfax] = useState(true)

  const [feedPdfObj, setFeedPdfObj] = useState({})
  const [scrapingFrom, setScrapingFrom] = useState('Select an Auction')
  const [sortBy, setSortBy] = useState('auction_date,ASC')
  const [shouldScrapeAuctionDisable, SetShouldScrapeAuctionDisable] = useState(true)


  const [progressMMR, SetProgressMMR] = useState('')
  const [progressCarfax, SetProgressCarfax] = useState('')
  const [progressAdesa, SetProgressAdesa] = useState('')
  const [progressAdesaUS, SetProgressAdesaUS] = useState('')
  const [progressAutoNation, SetProgressAutoNation] = useState('')
  const [activeID, SetActiveID] = useState('')
  const [showingProgress, SetShowingProgress] = useState('X%')

  const dataProvider = useDataProvider();



  useEffect(() => {
    SetShouldScrapeAuctionDisable(scrapingFrom == 'Select an Auction' || scrapingFrom == 'Adesa' && isScrapingAdesa || scrapingFrom == 'Adesa US' && isScrapingAdesaUS || scrapingFrom == 'Auto Nation' && isScrapingAutoNation)

  }, [scrapingFrom, isScrapingAdesa, isScrapingAdesaUS, isScrapingAutoNation])

  useEffect(() => {
    if (scrapingFrom == 'Adesa') {
      console.log('scrapingFrom = Adesa', progressAdesa);
      SetShowingProgress(progressAdesa)
    }
    else if (scrapingFrom == 'Adesa US') {
      console.log('scrapingFrom = Adesa US', progressAdesaUS);
      SetShowingProgress(progressAdesaUS)
    }
    else if (scrapingFrom == 'Auto Nation') {
      console.log('scrapingFrom = Auto Nation', progressAutoNation);
      SetShowingProgress(progressAutoNation)
    }

  }, [scrapingFrom, progressAdesa, progressAdesaUS, progressAutoNation])

  useEffect(() => {
    // console.log('ids---', ids);
    dataProvider.getList('cars', { pagination: { page: 1, perPage: 9999999999 }, sort: currentSort, filter: filterValues })
      .then(({ data: carsArr }) => {
        let hasEmptyCarfax = carsArr.some((car) => (car.carfax == null || car.carfax == ''))
        let hasEmptyMMR = carsArr.some((car) => (car.mmr == null || car.mmr == ''))
        // console.log('hasEmptyCarfax--', hasEmptyCarfax, 'hasEmptyMMR--', hasEmptyMMR);
        setHasEmptyCarfax(hasEmptyCarfax)
        setHasEmptyMMR(hasEmptyMMR)
      })
  }, [])

  useEffect(() => {

    clearInterval(activeID);
    let id = setInterval(async () => {
      await keepAccessTokenUpdated()
      // console.log('filterValues', filterValues);
      // dataProvider.getList('cars', { pagination: { page, perPage }, sort: currentSort, filter: filterValues })
      //   .then(({ data: carsArr }) => {
      //     let hasEmptyCarfax = carsArr.some((car) => car.carfax == null)
      //     let hasEmptyMMR = carsArr.some((car) => car.mmr == null)
      //     setHasEmptyCarfax(hasEmptyCarfax)
      //     setHasEmptyMMR(hasEmptyMMR)
      //   })

      let allProgress = await GetProgress()
      // console.log(rest);

      allProgress && allProgress.forEach((oneTypeProgress) => {
        let { type, status, todo, done, start_time } = oneTypeProgress
        if (type == 'mmr') {
          setIsScrapingMMR(status == 'In-progress')
          done != null && todo != null && SetProgressMMR(`${Math.round(done * 100 / todo).toString()}%`)
        }
        else if (type == 'carfax') {
          setIsScrapingCarfax(status == 'In-progress')
          done != null && todo != null && SetProgressCarfax(`${Math.round(done * 100 / todo).toString()}%`)
        }
        else if (type == 'auto nation watchlist') {
          setIsScrapingAutoNation(status == 'In-progress')
          done != null && todo != null && SetProgressAutoNation(`${Math.round(done * 100 / todo).toString()}%`)
        }
        else if (type == 'adesa watchlist') {
          setIsScrapingAdesa(status == 'In-progress')
          done != null && todo != null && SetProgressAdesa(`${Math.round(done * 100 / todo).toString()}%`)
        }
        else if (type == 'adesa US watchlist') {
          setIsScrapingAdesaUS(status == 'In-progress')
          done != null && todo != null && SetProgressAdesaUS(`${Math.round(done * 100 / todo).toString()}%`)
        }
      })


    }, 3000)

    SetActiveID(id)

    // returned function will be called on component unmount 
    return () => { clearInterval(id) }


  }, [page, perPage, currentSort])



  const downloadButtonClicked = () => {
    setIsLoadingPDF(true)
    dataProvider.getList('cars', { pagination: { page: 1, perPage: 999999 }, sort: { field: 'lane_number', order: 'ASC' }, filter: filterValues })
      .then(({ data: carsArr }) => {
        let feedPdfObj = {}

        for (let index = 0; index < carsArr.length; index++) {
          const car = carsArr[index];
          let lane = car.lane_number || 'No Lane'


          if (!feedPdfObj[lane])
            feedPdfObj[lane] = []

          feedPdfObj[lane].push(car)
        }

        Object.keys(feedPdfObj).forEach((lane) => {
          feedPdfObj[lane].sort((aCar, bCar) => aCar.run_number - bCar.run_number)
        })

        setFeedPdfObj(feedPdfObj)
        setIsLoadingPDF(false)

      })
      .then(() => {

        let downloadlink = null
        let theIntrval = null

        theIntrval = setInterval(() => {
          downloadlink = document.querySelector(`a[download='Homework.pdf']`)
          if (!downloadlink.innerHTML.includes('Loading document')) {
            clearInterval(theIntrval);
            downloadlink.click()
          }
        }, 500);



      });
  }

  const scrapeCarfaxButtonClicked = () => {

    UpdateProgress({ type: 'carfax', status: 'In-progress', done: 0 })
      .then(() => {
        setIsScrapingCarfax(true)
        SetProgressCarfax('0%')
        Scrape('carfax')
          .then(() => {
            window.location.reload(); //fix list stale data
          })
      })

  }
  const scrapeMMRButtonClicked = () => {

    UpdateProgress({ type: 'mmr', status: 'In-progress', done: 0 })
      .then(() => {
        setIsScrapingMMR(true)
        SetProgressMMR('0%')
        Scrape('mmr')
          .then(() => {
            window.location.reload(); //fix list stale data
          })
      })

  }
  const scrapeBasicInfoButtonClicked = () => {
    if (scrapingFrom == 'Adesa') {

      UpdateProgress({ type: 'adesa watchlist', status: 'In-progress', done: 0 })
        .then(() => {
          setIsScrapingAdesa(true)
          SetProgressAdesa('0%')
          Scrape('adesa')
            .then(() => {
              window.location.reload(); //fix list stale data
            })
        })
    }
    else if (scrapingFrom == 'Adesa US') {

      UpdateProgress({ type: 'adesa US watchlist', status: 'In-progress', done: 0 })
        .then(() => {
          setIsScrapingAdesaUS(true)
          SetProgressAdesaUS('0%')
          Scrape('adesaUS')
            .then(() => {
              window.location.reload(); //fix list stale data
            })
        })
    }
    else if (scrapingFrom == 'Auto Nation') {
      UpdateProgress({ type: 'auto nation watchlist', status: 'In-progress', done: 0 })
        .then(() => {
          setIsScrapingAutoNation(true)
          SetProgressAutoNation('0%')
          Scrape('autonation')
            .then(() => {
              window.location.reload(); //fix list stale data
            })
        })

    }


  }


  const sortMethodOnChange = e => {
    let v = e.target.value
    let vArr = v.split(',')

    const encodedFilter = encodeURI(`${JSON.stringify(filterValues)}`)
    window.location.replace(`/?#/cars/?filter=${encodedFilter}&page=${page}&perPage=${perPage}&sort=${vArr[0]}&order=${vArr[1]}`);

    setSortBy(v)
  }

  return (
    <TopToolbar style={{ width: '60%' }} className={className} {...sanitizeListRestProps(rest)}>
      <div style={{ display: 'none' }}><Link toDownload={MyDoc(feedPdfObj)} /></div>

      <div>
        <InputLabel >Sort By: </InputLabel>
        <Select onChange={sortMethodOnChange} value={sortBy}>
          <MenuItem value='auction_name,ASC'>Auction Name (A to Z)</MenuItem>
          <MenuItem value='auction_name,DESC'>Auction Name (Z to A)</MenuItem>
          <MenuItem value='lane_number,ASC'>Lane (A to Z)</MenuItem>
          <MenuItem value='lane_number,DESC'>Lane (Z to A)</MenuItem>
          <MenuItem value='auction_date,ASC'>Auction Date (Early to Late)</MenuItem>
          <MenuItem value='auction_date,DESC'>Auction Date (Late to Early)</MenuItem>
        </Select>
      </div>


      {
        ids.length > 0 && (
          <Input
            type='number'
            style={{ width: '15%' }}
            onChange={(e) => { setRate(e.target.value) }}
            inputProps={{ step: 0.01, min: 0 }}
            value={rate}
            startAdornment={(<InputAdornment position='start'>Rate:</InputAdornment>)}
          />
        )
      }



      &nbsp;{ids.length > 0 && filters && cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}

&nbsp; <Button onClick={scrapeCarfaxButtonClicked}
        disabled={!hasEmptyCarfax || isScrapingCarfax}
        label={isScrapingCarfax ? `Scraping Carfax....${progressCarfax}` : `Carfax`}
        variant="contained"
        color="primary" />
&nbsp; <Button
        onClick={scrapeMMRButtonClicked}
        disabled={!hasEmptyMMR || isScrapingMMR}
        label={isScrapingMMR ? `Scraping MMR....${progressMMR}` : `MMR`}
        variant="contained"
        color="primary" />

&nbsp; { !filterValues.in_cart &&
        <Button
          onClick={scrapeBasicInfoButtonClicked}
          disabled={shouldScrapeAuctionDisable}
          label={scrapingFrom == 'Select an Auction' || !shouldScrapeAuctionDisable ? `Scrape From` : `(${showingProgress}) Scraping....`}
          variant="contained"
          color="primary" />
      }

&nbsp;{ !filterValues.in_cart &&
        <Select
          autoWidth={true}
          value={scrapingFrom}
          onChange={(e) => { setScrapingFrom(e.target.value) }}
        >
          <MenuItem disabled={true} value={'Select an Auction'}>Select an Auction</MenuItem>
          <MenuItem value={'Adesa'}>Adesa</MenuItem>
          <MenuItem value={'Adesa US'}>Adesa US</MenuItem>
          <MenuItem value={'Auto Nation'}>Auto Nation</MenuItem>
        </Select>
      }
&nbsp;
      {
        filterValues.in_cart && (<Button onClick={downloadButtonClicked} disabled={isLoadingPDF} label={isLoadingPDF ? `Processing...` : `Download PDF`} variant="contained" color="primary" />)
      }


    </TopToolbar>
  )
}


const Filters = props => {
  return (
    <Filter {...props}>
      <TextInput resettable alwaysOn label='Search by Auction' style={{ minWidth: 'fit-content' }} source='auction_name' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
      <TextInput resettable label='Search by Lane' source='lane_number' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
      <TextInput resettable label='Search by Run' source='run_number' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
      <TextInput resettable label='Search by VIN' source='vin' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
      <BooleanInput alwaysOn label='🛒In Cart' source='in_cart' />
    </Filter>
  )
}

const BulkActionButtons = props => {

  let { filterValues: { in_cart } } = props

  return (
    <Fragment>
      <BulkActionButton field="in_cart" value={!in_cart} label={`${in_cart ? 'Remove from' : 'Add to'} Cart`} {...props} />&nbsp;
      <BulkDeleteButton {...props} />
    </Fragment>
  )
}



const CarList = (props) => {

  const [open, setOpen] = useState(false)
  const [vin, setVin] = useState('')
  const [carfaxCode, setCarfaxCode] = useState('')
  const [rate, setRate] = useState(1.23)

  const handleDialogClose = () => {
    setOpen(false)
  }

  return (
    <Fragment>

      <List
        {...props}
        filterDefaultValues={{ in_cart: false }}
        sort={{ field: 'auction_date', order: 'ASC' }}
        actions={<ListActions setRate={setRate} rate={rate} />}
        filters={<Filters />}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]} />}
        bulkActionButtons={<BulkActionButtons />}
      >
        <Datagrid>
          <TheBox setOpen={setOpen} setCarfaxCode={setCarfaxCode} setVin={setVin} rate={rate} />

        </Datagrid>
      </List>

      <Dialog open={open} fullWidth={true} maxWidth={'xl'} >
        <DialogTitle>Carfax for {vin}</DialogTitle>
        <DialogContent   >

          <ResponsiveIFrame carfaxCode={carfaxCode} />

        </DialogContent>
        <DialogActions>
          <MaterialUIButton variant="contained" onClick={handleDialogClose}>
            ❌Close
            </MaterialUIButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}

export default CarList
